var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.componentByType,_vm._b({tag:"component",attrs:{"size":_vm.size}},'component',_vm.$attrs,false)),_vm._t("message",function(){return [(_vm.message)?_c('div',[_c('h1',[_vm._v(_vm._s(_vm.message))])]):_vm._e()]},{"message":_vm.message})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }